import { Component, Input } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-phone-filter',
  templateUrl: './phone-filter.component.html',
  styleUrls: ['./phone-filter.component.scss']
})
export class PhoneFilterComponent extends BaseFilterCellComponent
{
  @Input() public filter: CompositeFilterDescriptor;
  @Input() public filterField: string;
  @Input() public phoneNumberMask: string;

  constructor(filterService: FilterService)
  {
    super(filterService);
  }

  public onChange(value: any): void
  {
    let filteredValue = value.replace(/ /g, '');
    // Since this is a contains, if the phone is not totally filled, the - is being removed.
    if (filteredValue.length > 0 && filteredValue[filteredValue.length - 1] === '-')
    {
      filteredValue = filteredValue.replace(/-/g, '');
    }
    this.applyFilter(
      value === null || value === '' ?          // value of the default item
        this.removeFilter(this.filterField) :   // remove the filter
        this.updateFilter({                     // add a filter for the field with the value
          field: this.filterField,
          operator: 'contains',
          // Currently removing blank from phone prior query. This could be remove later when phone are save without mark (PAYER-2540)
          value: filteredValue
        })
    );
  }
}
